module.exports = __webpack_public_path__ + "static/motunrayo-48cf05201a5f02e67dbb97684d2f94ba.png";